var U = Object.defineProperty;
var x = (a, t, e) => t in a ? U(a, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[t] = e;
var d = (a, t, e) => x(a, typeof t != "symbol" ? t + "" : t, e);
import { defineComponent as N, toRefs as D, computed as R, createBlock as b, openBlock as u, unref as s, withModifiers as $, withCtx as C, createElementVNode as S, createVNode as f, toDisplayString as v, ref as F, watch as L, createElementBlock as g, normalizeStyle as M, createCommentVNode as G, Fragment as p, renderList as A, normalizeClass as B } from "vue";
import { a as j, g as q, l as K, b as z, S as V, h as W, D as X, A as H, i as Y, s as T, d as J, c as _, e as Q, u as Z, L as w, f as tt, j as O, k as et, m as st } from "./main-CBt6LPao.mjs";
import nt from "@constructor-io/constructorio-client-javascript";
import { CdrLink as rt, CdrImg as at, CdrSkeleton as P, CdrSkeletonBone as I } from "@rei/cedar";
import { _ as ot } from "./SearchTermListbox.vue_vue_type_script_setup_true_lang-8PjIokKT.mjs";
const it = {
  searchSuggestions: "Search Suggestions",
  products: "Products"
}, ut = {
  "Search Suggestions": 10
}, ct = (a) => {
  const t = Object.entries(a || {}).reduce((e, [r, i]) => {
    const o = it[r];
    return o && (e[o] = i), e;
  }, {});
  return Object.keys(t).length > 0 ? t : ut;
}, lt = (a) => [
  // ...fetchFailMsgList,
  // https://constructor-io.github.io/constructorio-client-javascript/modules_autocomplete.js.html#line210
  "getAutocompleteResults response data is malformed"
].includes(a == null ? void 0 : a.message), m = class m {
  constructor(t, e) {
    /**
     * A Constructor apiKey is a workspace index key
     * that maps to a particular environment or context. (not considered secret)
     * https://app.constructor.io/dashboard/indexes
     * @private
     */
    d(this, "apiKey");
    /**
     * Remote Constructor API service endpoint
     * https://constructor-io.github.io/constructorio-client-javascript/ConstructorIO.html
     * @private
     */
    d(this, "serviceUrl");
    /**
     * Constructor autocomplete request configuration.
     *
     * This configuration is passed to Constructor.io's autocomplete API
     * and defines how autosuggest results are grouped and limited per filters or sections.
     */
    d(this, "autocompleteParams");
    /**
     * Constructor.io JavaScript client (external/third-party)
     * https://constructor-io.github.io/constructorio-client-javascript/index.html
     * @private
     */
    d(this, "constructorIO");
    /**
     * Tracks number of errors logged and is used as a check against spamming Datadog
     * if a repetitive error condition is reached with some allowance for optional retry
     * but largely due to the high frequency nature of autosuggest UI keyboard input behavior.
     * @private
     */
    d(this, "loggedErrorCount");
    /**
     * REI CIAM user id, if available due to user being logged in.
     * https://rei-coop.atlassian.net/wiki/spaces/OC/pages/4786229/Customer+Identity+and+Access+Management+CIAM+Overview
     * @private
     */
    d(this, "userId");
    this.initProperties(t, e);
  }
  /**
   * Initializes instance properties during class construction
   * @param {string} apiKey Constructor API index reference
   * @param {string} serviceUrl Remote Constructor API service endpoint
   * @private
   */
  initProperties(t, e) {
    this.apiKey = t, this.serviceUrl = e, this.autocompleteParams = {
      resultsPerSection: ct(
        j.value || q.c9rAutosuggestSectionResults
      )
    }, this.constructorIO = null, this.loggedErrorCount = 0, this.userId = null, m.instance = this;
  }
  /**
   * Getter and factory method for Constructor third-party API client that holds autocomplete module
   * @private
   * @return Promise<ConstructorIO>
   */
  async getC9rClientInstance() {
    if (!this.constructorIO) {
      const t = await k.getOnlineAccountNumber();
      this.userId = t || null, this.constructorIO = new nt({
        apiKey: this.apiKey,
        serviceUrl: this.serviceUrl,
        userId: this.userId
      });
    }
    return this.constructorIO;
  }
  /**
   * Getter and singleton factory method for this class
   * @param {string} apiKey Constructor API index reference
   * @param {string} serviceUrl Remote Constructor API service endpoint
   */
  static getInstance(t, e) {
    return m.instance || (m.instance = new m(
      t,
      e
    )), m.instance;
  }
  /**
   * Mostly a unit test utility
   */
  static teardownInstance() {
    m.instance = void 0;
  }
  /**
   * Main autosuggest results getter with no error logging.
   * that initializes external ConstructorIO client on first attempt.
   * Public access deprecated in favor of `getAutosuggestResultsWithErrLogAndRetry`.
   * @param {string} searchTerm
   * @param {IAutocompleteParameters} autocompleteParams
   */
  async getAutosuggestResults(t, e = this.autocompleteParams) {
    return (await this.getC9rClientInstance()).autocomplete.getAutocompleteResults(t, e);
  }
  /**
   * Preferred main autocomplete/autosuggest results getter that wraps getAutosuggestResults
   * and offers limited logging and an optional retry for certain error patterns.
   * @param {string} searchTerm
   * @param {IAutocompleteParameters} autocompleteParams
   * @param {{ count: number, limit: number }} retryConfig
   * @return {unknown}
   */
  async getAutosuggestResultsWithErrLogAndRetry(t, e, r = { count: 0, limit: 0 }) {
    let i;
    try {
      i = await this.getAutosuggestResults(t, e);
    } catch (o) {
      const { count: c, limit: l } = r, n = {
        source: "getAutosuggestResultsWithErrLogAndRetry",
        isErrorRetryable: lt(o),
        autocompleteParams: e,
        retryConfig: r,
        searchTerm: t
      };
      if (this.resolveError(o, n), n.isErrorRetryable && l && c < l) {
        const h = { ...r };
        h.count += 1, i = await this.getAutosuggestResultsWithErrLogAndRetry(t, e, h);
      }
    }
    return i;
  }
  /**
   * Provides wrapper for logging errors using logger util and provides:
   * - A limit guard for logging to allow a single log per session/instance
   *   that is padded for any retry limit for the first error
   * - Common context data that is shared by any error in this class
   * @param {Error} error
   * @param {object} context
   * @private
   */
  resolveError(t, e) {
    const { retryConfig: { limit: r = 0 } } = e;
    if (this.loggedErrorCount < r + 1) {
      const { apiKey: i, serviceUrl: o, userId: c } = this;
      K(t, {
        ...e,
        source: `AutosuggestClient.${e.source}`,
        apiKey: i,
        serviceUrl: o,
        userId: c,
        vendor: "C9r"
      }), this.loggedErrorCount += 1;
    }
  }
};
d(m, "instance");
let E = m;
const gt = async (a, t) => E.getInstance(
  // apiKey is index key, not considered secret
  // https://app.constructor.io/dashboard/indexes
  "key_9Mi6wJ14xYHiFlPx",
  "https://ezeubuswo-zone.cnstrc.com/"
).getAutosuggestResultsWithErrLogAndRetry(
  a,
  t
), y = class y {
  /**
   * Get the singleton instance of UserService
   */
  static getInstance() {
    return y.instance || (y.instance = new y()), y.instance;
  }
  /**
   * Gets the online account number from utag_data or by API call
   * @returns A promise that resolves to the online account number or null
   */
  static async getOnlineAccountNumber() {
    const t = window == null ? void 0 : window.utag_data, { isLoggedIn: e, onlineAccountNumber: r } = t || {};
    if (e === "logged in" && r)
      return r;
    if (!t) {
      const i = await y.fetchUser();
      return typeof (i == null ? void 0 : i.accountId) == "string" ? i.accountId : null;
    }
    return null;
  }
  /**
   * Fetches user data from the API
   * @returns A promise that resolves to user data or null
   */
  static async fetchUser() {
    try {
      const t = await fetch("/rest/user/account");
      return t.ok ? await t.json() : null;
    } catch {
      return null;
    }
  }
};
d(y, "instance");
let k = y;
const dt = {
  class: "product-suggestion-card__image-container"
}, mt = {
  class: "product-suggestion-card__content"
}, ht = {
  class: "product-suggestion-card__brand"
}, _t = {
  class: "product-suggestion-card__name"
}, yt = /* @__PURE__ */ N({
  __name: "ProductSuggestionTile",
  props: {
    id: {},
    styleId: {},
    brand: {},
    name: {},
    url: {},
    imageUrl: {},
    index: {}
  },
  setup(a) {
    const {
      listboxActiveItemIndex: t,
      listboxActiveSectionIndex: e
    } = D(z), r = R(() => a.index === t.value && e.value === V), i = R(() => `${a.brand} ${a.name}`);
    return (o, c) => (u(), b(s(rt), {
      id: `${s(H).PRODUCTS}${o.index}`,
      ref: "linkRef",
      "aria-selected": r.value,
      href: o.url,
      "aria-label": i.value,
      "data-cnstrc-item-id": o.styleId,
      "data-cnstrc-item-name": i.value,
      "data-cnstrc-item-section": s(X).PRODUCTS,
      role: "option",
      modifier: "standalone",
      tabindex: "-1",
      class: "product-suggestion-card",
      onMousedown: c[0] || (c[0] = $((l) => s(W)(o.index), ["left"]))
    }, {
      default: C(() => [S("div", dt, [f(s(at), {
        src: o.imageUrl,
        alt: o.name,
        class: "product-suggestion-card__image"
      }, null, 8, ["src", "alt"])]), S("div", mt, [S("span", ht, v(o.brand), 1), S("span", _t, v(o.name), 1)])]),
      _: 1
    }, 8, ["id", "aria-selected", "href", "aria-label", "data-cnstrc-item-id", "data-cnstrc-item-name", "data-cnstrc-item-section"]));
  }
}), St = {
  class: "search-autosuggest__container"
}, ft = {
  class: "search-autosuggest__container__middle"
}, pt = {
  class: "search-autosuggest__listbox-section"
}, At = {
  key: 0,
  class: "search-autosuggest__products-section"
}, It = {
  key: 0,
  class: "search-autosuggest__products-grid",
  "data-js": "search-autosuggest-products-grid"
}, bt = ["aria-label"], Tt = /* @__PURE__ */ N({
  __name: "SearchAutosuggest",
  setup(a) {
    let t = null, e = !1;
    const r = F(null);
    async function i(c) {
      const l = _.autosuggestSearchSuggestions.length;
      e = !0, l === 0 ? O() : t = setTimeout(() => {
        e && O();
      }, et);
      const n = await gt(c);
      e = !1, t && (clearTimeout(t), t = null), st(), T(n);
    }
    const o = J(i, 100);
    return L(() => Y.cleanQuery, async (c) => {
      if (!c) {
        T({});
        return;
      }
      o(c);
    }), L(() => _.autosuggestSearchSuggestions, (c) => {
      r.value && c.length && requestAnimationFrame(() => {
        var l;
        (l = r == null ? void 0 : r.value) == null || l.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });
    }), (c, l) => (u(), g("div", {
      ref_key: "searchAutosuggestRef",
      ref: r,
      class: "search-autosuggest",
      style: M({
        top: `${s(Q).navHeight}px`
      })
    }, [S("div", St, [S("div", ft, [S("div", pt, [s(_).isAutosuggestLoading ? (u(), b(s(P), {
      key: 0,
      class: "search-autosuggest__skeleton"
    }, {
      default: C(() => [(u(!0), g(p, null, A(s(_).previousAutosuggestSearchSuggestionsLength, (n) => (u(), b(s(I), {
        key: "skeleton-autosuggest" + n,
        type: "line",
        class: "search-autosuggest__skeleton__skeleton-bone"
      }))), 128))]),
      _: 1
    })) : (u(), b(ot, {
      key: 1,
      id: "gnav-suggestion-list",
      "data-cnstrc-autosuggest": "",
      suggestions: s(_).autosuggestSearchSuggestions,
      "aria-label": s(w).AUTOSUGGEST,
      onItemActivate: l[0] || (l[0] = (n) => s(Z)(n.term))
    }, {
      default: C(({
        item: n
      }) => [(u(!0), g(p, null, A(n.termParts, (h) => (u(), g("span", {
        key: h.key,
        class: B(["search-autosuggest__item-part", {
          "search-autosuggest__item-part--query-text": h.queryText
        }])
      }, v(h.text), 3))), 128))]),
      _: 1
    }, 8, ["suggestions", "aria-label"]))]), s(tt) ? (u(), g("div", At, [s(_).isAutosuggestLoading ? (u(), g("div", It, [(u(!0), g(p, null, A(s(_).previousAutosuggestProductSuggestionsLength, (n) => (u(), g("div", {
      key: "skeleton-product-" + n,
      class: "search-autosuggest__product-skeleton-item"
    }, [f(s(P), null, {
      default: C(() => [f(s(I), {
        type: "square",
        class: "search-autosuggest__skeleton-image"
      }), f(s(I), {
        type: "line"
      }), f(s(I), {
        type: "line"
      })]),
      _: 1
    })]))), 128))])) : (u(), g("ul", {
      key: 1,
      class: "search-autosuggest__products-grid",
      role: "listbox",
      "aria-label": s(w).PRODUCT_SUGGESTIONS
    }, [(u(!0), g(p, null, A(s(_).autosuggestProductSuggestions, (n, h) => (u(), g("li", {
      key: n.key
    }, [f(yt, {
      id: n.key,
      "style-id": n.styleId,
      brand: n.brand,
      name: n.name,
      url: n.url,
      "image-url": n.imageUrl,
      index: h
    }, null, 8, ["id", "style-id", "brand", "name", "url", "image-url", "index"])]))), 128))], 8, bt))])) : G("", !0)])])], 4));
  }
});
export {
  Tt as default
};
